module.exports = __webpack_public_path__ + "static/media/announcement.2c41967c.png";